import React from 'react';
import './ContactInfo.css';

const isMobile = () => /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const PHONE = '+917087980024';
const PHONE_DISPLAY = '+91 70879 80024';
const EMAIL = 'connect@campusxl.in';
const WHATSAPP = '+917087980024';
const WHATSAPP_MSG = encodeURIComponent('Hi CampusXL! I would like to know more about your programs. Shall we chat? Thank you!');

const handlePhoneClick = (e) => {
  if (!isMobile()) e.preventDefault();
};

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.45 2 2 0 0 1 3.59 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.83a16 16 0 0 0 6.29 6.29l1.42-1.42a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const ContactInfo = () => (
  <section id="contact" className="contact-info section">
    <div className="ci-inner section-inner">

      <div className="ci-header">
        <h2 className="ci-title">Get in Touch</h2>
        <p className="ci-subtitle">Reach out to us directly — we're happy to help you find the right program.</p>
      </div>

      <div className="ci-cards">

        {/* Phone */}
        <a
          href={`tel:${PHONE}`}
          className="ci-card ci-card--phone"
          onClick={handlePhoneClick}
          aria-label="Call us"
        >
          <span className="ci-icon"><PhoneIcon /></span>
          <div className="ci-card-body">
            <span className="ci-label">Call Us</span>
            <span className="ci-value">{PHONE_DISPLAY}</span>
            <span className="ci-hint">Tap to dial</span>
          </div>
          <span className="ci-cta">
            <span className="ci-cta-text">Click here</span>
          </span>
        </a>

        {/* Email */}
        <a
          href={`mailto:${EMAIL}`}
          className="ci-card ci-card--email"
          aria-label="Email us"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="ci-icon"><EmailIcon /></span>
          <div className="ci-card-body">
            <span className="ci-label">Email Us</span>
            <span className="ci-value">{EMAIL}</span>
            <span className="ci-hint">Opens your mail app</span>
          </div>
          <span className="ci-cta">
            <span className="ci-cta-text">Click here</span>
          </span>
        </a>

        {/* WhatsApp */}
        <a
          href={`https://wa.me/${WHATSAPP}?text=${WHATSAPP_MSG}`}
          target="_blank"
          rel="noreferrer"
          className="ci-card ci-card--whatsapp"
          aria-label="WhatsApp us"
        >
          <span className="ci-icon"><WhatsAppIcon /></span>
          <div className="ci-card-body">
            <span className="ci-label">WhatsApp</span>
            <span className="ci-hint">Opens WhatsApp chat</span>
          </div>
          <span className="ci-cta">
            <span className="ci-cta-text">Click here</span>
          </span>
        </a>

      </div>

      {/* Social */}
      <div className="ci-social">
        <span className="ci-social-label">Follow us</span>
        <div className="ci-social-icons">
          <a href="https://www.instagram.com/campusxl.in?igsh=MTM1aG5lOTJqOXVjbQ==" target="_blank" rel="noreferrer" className="ci-social-btn ci-social-btn--instagram" aria-label="Instagram">
            <InstagramIcon />
          </a>
          <a href="https://www.linkedin.com/company/campusxl/" target="_blank" rel="noreferrer" className="ci-social-btn ci-social-btn--linkedin" aria-label="LinkedIn">
            <LinkedInIcon />
          </a>
        </div>
      </div>

    </div>

    <footer className="footer">
      <span>© 2026 CampusXL Pvt Ltd. All rights reserved.</span>
    </footer>
  </section>
);

export default ContactInfo;
